module.exports = __webpack_public_path__ + "static/media/gallery1.d9686514.jpg";